export const environment = {
	production: false,
	apiUrl: 'https://backend.patinformed.globaldb.dev.web1.wipo.int'
};
